import { getAssetUrl } from "../../../api/api";
import iBluePolygon from "../../../assets/icons/blue-polygon.svg";
import "./cases-featured-bullet-item.sass";

type Props = {
  bulletText: string;
  bulletTitle: string;
  description: string;
  image: {
    url: string;
  };
};

const CasesFeaturedBulletItem = ({
  bulletText,
  bulletTitle,
  description,
  image,
}: Props) => {
  return (
    <div className="cases-featured-bullet-item">
      <div className="cases-featured-bullet-item__content">
        <div className="cases-featured-bullet-item__description">
          {description}
        </div>

        <div className="cases-featured-bullet-item__bullet">
          <div className="cases-featured-bullet-item__title">
            <img
              src={iBluePolygon}
              alt=""
              className="cases-featured-bullet-item__polygon"
            />

            <div className="cases-featured-bullet-item__bullet-title">
              {bulletTitle}
            </div>
          </div>

          <div className="cases-featured-bullet-item__bullet-text">
            {bulletText}
          </div>
        </div>
      </div>

      <img
        src={getAssetUrl(image.url)}
        alt=""
        className="cases-featured-bullet-item__image"
      />
    </div>
  );
};

export default CasesFeaturedBulletItem;
